import { LLM_REASONING_ARG_NAME } from './constants'

/** Return input without the synthetic `llmReasoning` field. */
export function removeLlmReasoningArg<T extends object>(
  input: T,
): Omit<T, typeof LLM_REASONING_ARG_NAME> {
  if (!(LLM_REASONING_ARG_NAME in input)) {
    return input
  }

  const inputClone = { ...input }
  delete inputClone[LLM_REASONING_ARG_NAME]
  return inputClone
}
